import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../screens/login/login";

const RouteConfig: React.FunctionComponent = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="dashboard"></Route>
      </Routes>
    </div>
  );
};

export default RouteConfig;
